// Clause deep link: opens the Library contents tab of the clause's document with the clause selected, in the active region.
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { useRegionParam } from "@/app/region";
import { cn, linkClass } from "@/lib/cn";
import { docUidOf } from "@/lib/url";

interface ClauseLinkProps {
  clauseUid: string;
  number?: string | null;
  region?: string;
  children?: ReactNode;
  className?: string;
}

export function ClauseLink({ clauseUid, number, region, children, className }: ClauseLinkProps) {
  const param = useRegionParam(region);
  const content = children ?? (
    <span className="font-mono text-xs">{number ?? clauseUid.slice(clauseUid.indexOf("#") + 1)}</span>
  );
  if (param === null) {
    return <span className={className}>{content}</span>;
  }
  return (
    <Link
      to="/$region/library/$docUid"
      params={{ region: param, docUid: docUidOf(clauseUid) }}
      search={{ tab: "contents", clause: clauseUid }}
      className={cn(linkClass, className)}
    >
      {content}
    </Link>
  );
}
